import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { BackofficeService } from "../../services/backoffice.service";
import {
  closeAlertAction,
  showAlertAction,
} from "../../store/actions/alert.action";
import {
  closeLoadingAction,
  showLoadingAction,
} from "../../store/actions/loading.action";
import { IAppState } from "../../store/state/app.state";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { merge, Observable, of as observableOf } from "rxjs";
import { catchError, map, startWith, switchMap } from "rxjs/operators";
import { iconsLibrary } from "../../../theme/constants";
import * as moment from "moment";
import { MatTableDataSource } from "@angular/material/table";
@Component({
  selector: "cowing-core-backoffice-spaces",
  templateUrl: "./backoffice-spaces.component.html",
  styleUrls: ["./backoffice-spaces.component.scss"],
})
export class BackofficeSpacesComponent implements AfterViewInit, OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  resultsLength: any;

  constructor(
    private _store: Store<IAppState>,
    private translate: TranslateService
  ) {}
  public displayedColumns: string[] = [];
  public dataSource = null;
  private buildSpace(data) {
    return {
      capacity: data.capacity,
      coworking_group_id: data.coworking_group_id,
      coworking_id: data.coworking_id,
      coworking_name: data.coworking_name,
      created_at: data.created_at,
      id: data.id,
      prices: data.prices,
      name: data.name,
      state_id: data.state_id,
      type_id: data.type_id,
      updated_at: data.updated_at,
    };
  }
  ngOnInit() {
    BackofficeService.instance.spaceModified.subscribe((val) => {
      this.paginator.page.emit();
    });
  }
  async ngAfterViewInit() {
    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this._store.dispatch(showLoadingAction({}));
          return BackofficeService.instance.getSpaces({
            page: this.paginator.pageIndex,
            pageSize: this.paginator.pageSize,
          });
        }),
        map((data) => {
          this._store.dispatch(closeLoadingAction({}));
          this.resultsLength = data.total_elements;
          return data["spaces"];
        }),
        catchError((e) => {
          this._store.dispatch(
            showAlertAction({
              payload: {
                message: e.error,
                title: this.translate.instant("general.caution"),
                type: "error",
              },
            })
          );
          this._store.dispatch(closeLoadingAction({}));
          return observableOf([]);
        })
      )
      .subscribe((data) => {
        const dataFiltered = data.map((space) => this.buildSpace(space));
        if (!this.displayedColumns.length) {
          this.displayedColumns = Object.keys(dataFiltered[0]);
          this.displayedColumns.push("actions");
        }
        this.dataSource = new MatTableDataSource(dataFiltered);
      });
  }

  public editSpace(space) {
    console.log(space);
    this._store.dispatch(
      showAlertAction({
        payload: {
          message: null,
          title: null,
          type: "editSpace",
          editSpaceId: space.id,
        },
      })
    );
  }

  public deleteSpace(company) {
    //   this._store.dispatch(
    //     showAlertAction({
    //       payload: {
    //         message: "",
    //         title: "Â¿Desea eliminar esta compaÃ±ia?",
    //         type: "deleteCompany",
    //         deleteCompanyId: company.id,
    //       },
    //     })
    //   );
  }

  dateFormatedLong(date) {
    return moment(date).lang("es").format("DD/MM/YYYY HH:mm");
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  public get getEditIcon() {
    return `${iconsLibrary.editBackoffice}`;
  }
  public get getDeleteIcon() {
    return `${iconsLibrary.trashBackoffice}`;
  }
}
